import capitals from './capitals'

export const getRoutes = () => {
  const routes = []

  capitals.slice(0, 30).forEach((ca) => {
    if (!['Ukraine', 'USA', 'United Kingdom'].includes(ca.country)) {
      capitals.slice(0, 15).forEach((child) => {
        if (
          ca.lat != child.lat &&
          ca.lng != child.lng &&
          !['Ukraine', 'USA', 'United Kingdom'].includes(child.country)
        ) {
          routes.push({
            startLat: ca.lat,
            startLng: ca.lng,
            endLat: child.lat,
            endLng: child.lng,
          })
        }
      })
    }
  })

  return routes
}

export default getRoutes
